<div class="auth-page">
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-brand">
        <img
          src="assets/favicon/android-chrome-192x192.png"
          [attr.alt]="'COMPONENTS.AUTH.BRAND_ALT' | translate"
          class="auth-brand-logo"
        />
        <h1 class="auth-brand-title">OrgLines</h1>
      </div>

      <form [formGroup]="formModel.form" (ngSubmit)="submitForm()" class="auth-form">
        <div>
          <label for="email-input" class="auth-field-label">{{ "INPUTS.EMAIL" | translate }}</label>
          <input
            id="email-input"
            type="email"
            class="input-field-lg auth-input w-full"
            [attr.placeholder]="'INPUTS.EMAIL' | translate"
            [formControlName]="formModel.fieldNames.email"
          />
        </div>

        <div>
          <label for="pwd-input" class="auth-field-label">{{ "INPUTS.PASSWORD" | translate }}</label>
          <input
            id="pwd-input"
            type="password"
            class="input-field-lg auth-input w-full"
            [attr.placeholder]="'INPUTS.PASSWORD' | translate"
            [formControlName]="formModel.fieldNames.password"
          />
        </div>

        <button
          type="submit"
          class="btn-primary auth-submit w-full rounded-xl"
          [disabled]="formModel.form.invalid"
        >
          {{ "BUTTONS.LOGIN" | translate }}
        </button>
      </form>

      <div class="auth-divider">
        <div class="auth-divider-line"></div>
        <span class="auth-divider-text">{{ "COMPONENTS.AUTH.OR" | translate }}</span>
        <div class="auth-divider-line"></div>
      </div>

      <div class="auth-links">
        <p>
          {{ "COMPONENTS.LOGIN.NO_ACCOUNT" | translate }}
          <a routerLink="/registration">{{ "COMPONENTS.LOGIN.REGISTER" | translate }}</a>
        </p>
        <a routerLink="/forgot-password">{{ "COMPONENTS.LOGIN.FORGOT_PASSWORD" | translate }}</a>
      </div>

      <div class="auth-divider">
        <div class="auth-divider-line"></div>
      </div>

      <div class="auth-language">
        <app-language-switcher [formControl]="formModel.form.controls.interfaceLanguage" />
      </div>
    </div>
    <p class="auth-footer-note">{{ "COMPONENTS.AUTH.FOOTER_NOTE" | translate }}</p>
  </div>
</div>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>
